"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordNoteService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordNoteService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordNoteService.instance) {
      return CordNoteService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordNoteService.instance = this;
  }
  getNotes(applicationId) {
    return this.get('applications/' + applicationId + '/notes');
  }
  saveNote(applicationId, note) {
    return this.post('applications/' + applicationId + '/notes', note);
  }
  deleteNote(noteId) {
    return this.delete('notes', noteId);
  }
}
exports.CordNoteService = CordNoteService;
CordNoteService.instance = null;
